var userAgent = require('../internals/engine-user-agent');

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/engine-is-ios.js
// module id = 576
// module chunks = 1